import React, { useState, useEffect } from "react";
import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../CustomComponents/Loader";
import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
import DynamicCard from "../../../../CustomComponents/DynamicCard";
import { appTheme, decimalValidation } from "../../../../../helpers/utils/Utils";
import {
  addLineBreaks,
  handleAmountInputLimitTo2decimal,
  handleAmountInputLimitTo2decimalForAmount,
  retrieveData,
} from "../../../../../utils";
import logFirebaseEvents from "../../../../LogFirebaseEvents";
import CardHeading from "../../../../CustomComponents/CardHeading";
import { withOidcSecure } from "@axa-fr/react-oidc";
import {
  ADD_SAVING_GOALS,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  PostRequest,
} from "../../../../../network/NetworkUtils";
 
const SavingGoalAmountField = ({
  cardFooter,
  onBack,
  onNext,
  handleAmountInput,
  onSave,
  onSetSpendSenseAlertFun,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const amount = useSelector((state) => state.savingGoals.amount);
  const name = useSelector((state) => state.savingGoals.name);
  const RESmsg = useSelector((state) => state.savingGoalResonseMsg);
  const [responseMsg, setResponseMsg] = useState();
  const selectedTargetDate = useSelector((state) => state.savingGoals.targetDate);
  const handleBackClick = () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Back_Saving_Goals_Clicked",
      "Back_Saving_Goals_Clicked",
      "",
      ""
    );
    onBack("SavingGoalFields");
  };
 
  
 
  const handleNextClick = () => {
    logFirebaseEvents("Saving_Goals", "Next_Saving_Goals_Clicked", "Next_Saving_Goals_Clicked","", "")
    if (!amount) setAmountError('Amount Required');
    if (amount && !amountError) onNext("SavingGoalDateField");
    dispatch({ type: 'SAVING_GOALS', payload: { key: "targetDate", value: selectedTargetDate } });
  }
 
  const handleOnBlur = (event) => {
    if (!amount) setAmountError("Amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else if (amount) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      const finalAmountVal = decimalValidation(formattedAmount)
      dispatch({
        type: "SAVING_GOALS",
        payload: {
          key: "amount",
          value: finalAmountVal,
        },
      });
   
    }
    else setAmountError("");
  };
 
 
  const amountValidation = () => {
    if (!amount) setAmountError("Amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else if (
      amount.endsWith(".") ||
      (amount.includes(".") && amount.split(".")[1].length < 2)
    ) {
      setIsNext(false);
    } else {
      setAmountError(null);
      setIsNext(true);
    }
  };

  useEffect(() => {
    if (amount) amountValidation();
    if (!amount) setIsNext(false);
  }, [amount]);
 

  
    
 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
         sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
              text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
        >
          {t("Access_code_Next")} {" "}
          <span className="text-[var(--text-body-clrs)]">
            {addLineBreaks(t("Set_Target_Amount"))}
          </span>
        </div>
 
        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className="md:my-32 sm:my-16 mt-10 mb-[10rem] sm:mx-0 mx-4">
              <div className="sm:w-[50%] w-full flex flex-col justify-center">
                <CustomTextInput
                  name={t("Target Amount")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      event.target.style.opacity = 0.8;
                      setTimeout(() => {
                        event.target.style.opacity = 1;
                      }, 200);
                    }
                  }}
                  onChange={(event) => {
                    const inputValue = event.target.value; // Remove invalid characters
                    const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
                    setAmountError('');
                    // if (formattedAmount === "0" || /^0[^.]/.test(formattedAmount)) {
                    //   return;
                    // }
 
                    // const [integerPart, decimalPart] =  formattedAmount.split(".");
                    // if (integerPart.length > 10) {
                    //   return;
                    // }
 
                    // Dispatch updated amount
                    dispatch({
                      type: "SAVING_GOALS", payload: { key: "amount", value: formattedAmount.toString().replace('$', '') }, });
                  }}
                  onBlur={(event) => handleOnBlur(event)}
                  error={amountError}
                  onFocus={(event) => {
                    if ((amount || "").endsWith(".00")){
                      const [integerPart] = amount.slice(0, -3).split(".");
                      const truncatedAmount = integerPart.length > 10  ? integerPart.slice(0, 10) : integerPart;
 
                      dispatch({
                        type: "SAVING_GOALS",
                        payload: { key: "amount", value: truncatedAmount },
                      });
                    }
                  }}
                  value={amount ? `$${amount}` : ""}
                  placeholder={"$ 0"}
                  inputWidth={`w-full`}
                  autoFocus={true}
                />
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}
 
        {cardFooter(handleBackClick, handleNextClick, "", "", isNext)}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Add_Saving_Goal")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
 
      {isLoading && <Loader />}
    </>
  );
};
 
export default withOidcSecure(SavingGoalAmountField);